var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"1em","width":"1em","viewBox":"0 0 48 48","fill":"currentColor"}},[_c('path',{attrs:{"d":"m24 40-2.1-2.15L34.25 25.5H8v-3h26.25L21.9 10.15 24 8l16 16Z","fill":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }